import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { JobList, JobListResponse } from '../interfaces/job-list';

export interface SalaryFilter {
  minSalary: number | null;
  maxSalary: number | null;
  salaryType: 'PER_HOUR' | 'PER_MONTH' | 'PER_YEAR';
}

export interface JobFilterParams {
  page?: number;
  size?: number;
  // Experience
  minExperience?: number;
  maxExperience?: number;
  // Salary
  salaryFilters?: SalaryFilter[];
  // Employment type  (e.g. 'Full-time', 'Part-time', 'Temporary')
  jobTypes?: string[];
  // Post kind: 'JOB' | 'INTERNSHIP'
  postTypes?: string[];
  // Date filter: 'LAST_24_HOURS' | 'LAST_3_DAYS' | 'LAST_7_DAYS'
  postingDate?: string;
  // Location: 'NEAR_ME' | 'REMOTE_JOB' | 'EXACT_LOCATION'
  location?: string;
  // Career level: 'ENTRY_LEVEL' | 'EXPERIENCED' | 'MANAGER' | 'SENIOR_MANAGER'
  careerLevels?: string[];
  // Partial-match search
  position?: string;
  department?: string;
}

@Injectable({ providedIn: 'root' })
export class JobListService {
  private apiUrl = `${environment.apiUrl}api/job-posts`;

  constructor(private http: HttpClient) {}
getJobs(filters: JobFilterParams = {}): Observable<JobList[]> {
  let queryParts: string[] = [];

  queryParts.push(`page=${filters.page ?? 0}`);
  queryParts.push(`size=${filters.size ?? 10}`);

  if (filters.minExperience != null)
    queryParts.push(`minExperience=${filters.minExperience}`);
  if (filters.maxExperience != null)
    queryParts.push(`maxExperience=${filters.maxExperience}`);

  filters.salaryFilters?.forEach((sf, i) => {
    if (sf.minSalary != null)
      queryParts.push(`salaryFilters[${i}].minSalary=${String(sf.minSalary)}`);
    if (sf.maxSalary != null)
      queryParts.push(`salaryFilters[${i}].maxSalary=${String(sf.maxSalary)}`);
    queryParts.push(`salaryFilters[${i}].salaryType=${sf.salaryType}`);
  });

  filters.jobTypes?.forEach((type) => {
    queryParts.push(`jobTypes=${encodeURIComponent(type)}`);
  });

  filters.postTypes?.forEach((type) => {
    queryParts.push(`postTypes=${encodeURIComponent(type)}`);
  });

  filters.careerLevels?.forEach((level) => {
    queryParts.push(`careerLevels=${encodeURIComponent(level)}`);
  });

  if (filters.postingDate)
    queryParts.push(`postingDate=${encodeURIComponent(filters.postingDate)}`);

  if (filters.location)
    queryParts.push(`location=${encodeURIComponent(filters.location)}`);

  if (filters.position)
    queryParts.push(`position=${encodeURIComponent(filters.position)}`);
  if (filters.department)
    queryParts.push(`department=${encodeURIComponent(filters.department)}`);

  const queryString = queryParts.join('&');
  const fullUrl = `${this.apiUrl}?${queryString}`;

  return this.http.get<JobListResponse>(fullUrl).pipe(
    map((response) => response.content ?? [])
  );
}

  getJobById(id: string): Observable<JobList> {
    return this.http.get<JobList>(`${this.apiUrl}/${id}`);
  }
}
